// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserContentForm_container__pfOmB {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .UserContentForm_formWrapper__lGkXn {
    width: 100%;
    max-width: 28rem;
    padding: 2rem;
    border-radius: 0.5rem;
    background-color: #2d2d2d;
    box-shadow: 0 0px 14px #ff000052;
  }
  
  .UserContentForm_form__tug2q {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .UserContentForm_title__Vms4s {
    font-size: 1.5rem;
    font-weight: bold;
    color: white;
    text-align: center;
    margin-bottom: 1.5rem;
  }
  
  .UserContentForm_formGroup__VahQ4 {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .UserContentForm_label__vmjbz {
    color: #d1d1d1;
    font-size: 0.875rem;
  }
  
  .UserContentForm_input__BK8d6 {
    width: 100%;
    padding: 1rem 0rem;
    border-radius: 0.25rem;
    background-color: #404040;
    border: 1px solid #525252;
    color: white;
    transition: border-color 0.2s;
  }
  
  .UserContentForm_input__BK8d6:focus {
    outline: none;
    border-color: #cc0000bf;
  }
  
  .UserContentForm_submitButton__LkTd3 {
    width: 100%;
    padding: 1rem 1rem;
    background-color: #cc0000eb;
    color: white;
    border: none;
    border-radius: 0.25rem;
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .UserContentForm_submitButton__LkTd3:hover {
    background-color: #f01a1a8e;
  }
  
  /* Add some placeholder styling */
  .UserContentForm_input__BK8d6::placeholder{
    color: #9ca3af;
  }

  /* Add these new styles to your existing CSS module file */
.UserContentForm_passwordWrapper__z8EhF {
    position: relative;
    width: 100%;
  }
  
  .UserContentForm_passwordToggle__AgROG {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #666;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .UserContentForm_passwordToggle__AgROG:hover {
    color: #333;
  }
  `, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/UserContentForm.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;IACE,cAAc;EAChB;;EAEA,0DAA0D;AAC5D;IACI,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb","sourcesContent":[".container {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .formWrapper {\n    width: 100%;\n    max-width: 28rem;\n    padding: 2rem;\n    border-radius: 0.5rem;\n    background-color: #2d2d2d;\n    box-shadow: 0 0px 14px #ff000052;\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .title {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: white;\n    text-align: center;\n    margin-bottom: 1.5rem;\n  }\n  \n  .formGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .label {\n    color: #d1d1d1;\n    font-size: 0.875rem;\n  }\n  \n  .input {\n    width: 100%;\n    padding: 1rem 0rem;\n    border-radius: 0.25rem;\n    background-color: #404040;\n    border: 1px solid #525252;\n    color: white;\n    transition: border-color 0.2s;\n  }\n  \n  .input:focus {\n    outline: none;\n    border-color: #cc0000bf;\n  }\n  \n  .submitButton {\n    width: 100%;\n    padding: 1rem 1rem;\n    background-color: #cc0000eb;\n    color: white;\n    border: none;\n    border-radius: 0.25rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: background-color 0.2s;\n  }\n  \n  .submitButton:hover {\n    background-color: #f01a1a8e;\n  }\n  \n  /* Add some placeholder styling */\n  .input::placeholder{\n    color: #9ca3af;\n  }\n\n  /* Add these new styles to your existing CSS module file */\n.passwordWrapper {\n    position: relative;\n    width: 100%;\n  }\n  \n  .passwordToggle {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #666;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .passwordToggle:hover {\n    color: #333;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UserContentForm_container__pfOmB`,
	"formWrapper": `UserContentForm_formWrapper__lGkXn`,
	"form": `UserContentForm_form__tug2q`,
	"title": `UserContentForm_title__Vms4s`,
	"formGroup": `UserContentForm_formGroup__VahQ4`,
	"label": `UserContentForm_label__vmjbz`,
	"input": `UserContentForm_input__BK8d6`,
	"submitButton": `UserContentForm_submitButton__LkTd3`,
	"passwordWrapper": `UserContentForm_passwordWrapper__z8EhF`,
	"passwordToggle": `UserContentForm_passwordToggle__AgROG`
};
export default ___CSS_LOADER_EXPORT___;
